import { createSlice } from "@reduxjs/toolkit";

export const BetDecisionSlice = createSlice({
    name: "BetDecisionSlice",
    initialState: {
        betDecisionUserData: {},
        userlast5Bets: [],
        customOddsList: {},
        referralList: [],
        betFilters: {},
        betReviewerStatus: {},
        activeReviewers: [],
        referralHistory: {},
        referralHistoryPage: 1,
        referralHistoryItems: 25,
        referralHistoryRecords: [1, 25],
        referralHistoryVisible: false,
    },
    reducers: {
        setBetDecisionUserData: (state, action) => {
            state.betDecisionUserData = action.payload;
        },
        setUserLast5Bets: (state, action) => {
            state.userlast5Bets = action.payload;
        },
        setCustomOddsList: (state, action) => {
            state.customOddsList = action.payload;
        },
        setReferralList: (state, action) => {
            state.referralList = action.payload;
        },
        addBetDecision: (state, action) => {
            const betId = String(action.payload.betId);
            const exists = state.referralList.some((r) => String(r.betId) === betId);
            if (!exists) {
                state.referralList = [{ ...action.payload, betId }, ...state.referralList];
            }
        },
        removeBetDecision: (state, action) => {
            const betId = String(action.payload);
            state.referralList = state.referralList.filter((r) => String(r.betId) !== betId);
        },
        extendBetDecision: (state, action) => {
            const betId = String(action.payload.betId);
            const item = state.referralList.find((r) => String(r.betId) === betId);
            if (item) item.extendedMs = (item.extendedMs || 0) + action.payload.extraMs;
        },
        updateBetReferralAction: (state, action) => {
            const betId = String(action.payload.betId);
            const item = state.referralList.find((r) => String(r.betId) === betId);
            if (!item) return;
            if (action.payload.expireTimestamp != null) {
                item.expireTimestamp = action.payload.expireTimestamp;
                item.extendedMs = 0;
            }
            if (action.payload.betDecision != null) {
                item.betDecision = action.payload.betDecision;
                item.expireTimestamp = null;
            }
            if (action.payload.platformUsername != null) {
                item.platformUsername = action.payload.platformUsername;
            }
        },
        getBetFilters: (state, action) => {
            state.betFilters = action.payload;
        },
        setActiveReviewers: (state, action) => {
            state.activeReviewers = action.payload;
        },
        setReferralHistory: (state, action) => {
            state.referralHistory = action.payload;
        },
        setReferralHistoryPage: (state, action) => {
            state.referralHistoryPage = action.payload;
        },
        setReferralHistoryItems: (state, action) => {
            state.referralHistoryItems = action.payload;
        },
        setReferralHistoryRecords: (state, action) => {
            state.referralHistoryRecords = action.payload;
        },
        setReferralHistoryVisible: (state, action) => {
            state.referralHistoryVisible = action.payload;
        },
        updateActiveReviewer: (state, action) => {
            const { eventType, userId, userName, firstName, lastName, userRole, eventTime } = action.payload;
            if (eventType === "LOGIN") {
                const exists = state.activeReviewers.some((r) => String(r.userId) === String(userId));
                if (!exists) {
                    state.activeReviewers = [
                        {
                            userId,
                            userName,
                            firstName: firstName || "",
                            lastName: lastName || "",
                            userRole,
                            loginTime: eventTime,
                            sessionToken: null,
                        },
                        ...state.activeReviewers,
                    ];
                }
            } else if (eventType === "LOGOUT" || eventType === "Expired" || eventType === "EXPIRED") {
                state.activeReviewers = state.activeReviewers.filter((r) => String(r.userId) !== String(userId));
            }
        },

        updateBetReviewerStatus: (state, action) => {
            const { betId, popupStatus, reviewedBy } = action.payload;
            const key = String(betId);
            if (popupStatus === "open") {
                state.betReviewerStatus[key] = { reviewedBy, popupStatus };
            } else if (popupStatus === "closed") {
                state.betReviewerStatus[key] = {
                    reviewedBy: state.betReviewerStatus[key]?.reviewedBy || reviewedBy,
                    popupStatus: "closed",
                };
            } else {
                delete state.betReviewerStatus[key];
            }
        },
    },
});
export const { setBetDecisionUserData, setUserLast5Bets, setCustomOddsList, setReferralList, addBetDecision, removeBetDecision, extendBetDecision, updateBetReferralAction, getBetFilters, updateBetReviewerStatus, setActiveReviewers, updateActiveReviewer, setReferralHistory, setReferralHistoryPage, setReferralHistoryItems, setReferralHistoryRecords, setReferralHistoryVisible } = BetDecisionSlice.actions;
export default BetDecisionSlice.reducer;
